export const getLimitedNumber = (val, min, step, precision) => {
  const multiple = 10 ** precision;
  const limitStep = step * multiple;
  const gap = Number(((val - min) * multiple).toFixed(2));
  const int = Math.floor(gap / limitStep);

  val = Number((min + int * step).toFixed(precision));
  return val;
};
